/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_AgendaInputs */



/**
* | output |
* | --- |
* | "Agenda" |
*
* @param {Settings_Tab_AgendaInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_tab_agenda = /** @type {((inputs?: Settings_Tab_AgendaInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_AgendaInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Agenda")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Agenda")
	return /** @type {LocalizedString} */ ("Agenda")
});